import { jsx as _jsx } from "react/jsx-runtime";
import { MarkdownBulletListIcon, MarkdownNumberedListIcon } from '@prophecy/icons';
import { BulletedListPlugin, NumberedListPlugin, useListToolbarButton, useListToolbarButtonState } from '@udecode/plate-list/react';
import { StyledButton } from './styled';
export function UnorderedListButton() {
    const state = useListToolbarButtonState({ nodeType: BulletedListPlugin.key });
    const { props } = useListToolbarButton(state);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', "data-active": props.pressed, onClick: props.onClick, icon: _jsx(MarkdownBulletListIcon, { type: 'extended' }), tooltip: 'Unordered List', "aria-label": 'Unordered List', "data-test-id": 'markdown-editor-unordered-list-button' }));
}
export function OrderedListButton() {
    const state = useListToolbarButtonState({ nodeType: NumberedListPlugin.key });
    const { props } = useListToolbarButton(state);
    return (_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', "data-active": props.pressed, onClick: props.onClick, icon: _jsx(MarkdownNumberedListIcon, { type: 'extended' }), tooltip: 'Ordered List', "aria-label": 'Ordered List', "data-test-id": 'markdown-editor-ordered-list-button' }));
}
